import api from "./api";

// ============================================================
// ADMIN SCHOOLS API
// ============================================================

export const AdminSchoolsAPI = {
  // ==========================================================
  // SCHOOLS
  // ==========================================================

  getAll: async () => {
    return api("/admin/schools");
  },

  create: async (payload) => {
    return api("/admin/schools", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  update: async (id, payload) => {
    return api(`/admin/schools/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  // ==========================================================
  // DOMAINS
  // ==========================================================

  addDomain: async (schoolId, payload) => {
    return api(`/admin/schools/${schoolId}/domains`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateDomain: async (domainId, payload) => {
    return api(`/admin/schools/domains/${domainId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  deleteDomain: async (domainId) => {
    return api(`/admin/schools/domains/${domainId}`, {
      method: "DELETE",
    });
  },

  // ==========================================================
  // ARBOR INTEGRATION
  // ==========================================================

  saveArborIntegration: async (schoolId, payload) => {
    return api(`/admin/schools/${schoolId}/arbor`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  deleteArborIntegration: async (schoolId) => {
    return api(`/admin/schools/${schoolId}/arbor`, {
      method: "DELETE",
    });
  },
};